const defaultState = {}

const logsReducer = (state = defaultState, action) => {
    // console.log("app reducer action = ", action)

    switch (action.type) {
        case 'SET_LOGS':
            return Object.assign({}, state, {
                logs: action.logs,
            })

        default:
            return state
    }
}

export default logsReducer
